export default __webpack_public_path__ + "static/continuous-compliance-mobile3-c609572a31f16411295b1202d398d221.jpg";